import { lastCharacters, localPart, domainPart } from './string-num-clean.js';
import { regularFilter as isEmail } from './validate-email.js';

/*
Method provider details

usage:
Deduce the account details of a user for a particular provider from the response data

return:
 string

*/

const trimEmail = val => `${lastCharacters(localPart(val), 4)}@${domainPart(val)}`;

const deduceProviderAccountDetails = val => {
	if (!val) return val;
	const account = isEmail(val) ? trimEmail(val) : lastCharacters(val, 4);

	return account ? `*${account}` : '';
};

export default deduceProviderAccountDetails;
